import {useEffect, useState} from 'react'
import {CountryModel} from '../modules/onboarding'
import {getCountry, state} from '../modules/onboarding/core/_requests'
import {getGovtIdTypes} from '../modules/stakeholders/founders-and-promoters/core/_requests'
import {useAuth} from '../modules/auth'
import { ShareholdersTypes } from '../modules/stakeholders/stakeholders-and-investors/core/_constants'
import { companyData } from '../modules/profile/core/_requests'
import { toast } from 'react-toastify'
import { useIntl } from 'react-intl'

export const useGetAllDropdownData = (shareholderType: ShareholdersTypes,formikRef?:any) => {
  const [countryOptions, setcountryOptions] = useState<any[]>([])
  const [stateOptions, setstateOptions] = useState<any>([])
  const [institutionStateOptions, setInstitutionStateOptions] = useState<any>([])
  const [countryLoading, setCountryLoading] = useState<boolean>(false)
  const [countryId, setCountryId] = useState<string | undefined>()
  const [institutionCountryId, setInstitutionCountryId] = useState<string | undefined>()
  const [govtIdOptions, setGovtIdOptions] = useState<any>()
  const [phoneCodesOptions, setPhoneCodesOptions] = useState<any>([])
  const [stateDataLoading, setStateDataLoading] = useState<boolean>(false)
  const [institutionStateDataLoading, setInstitutionStateDataLoading] = useState<boolean>(false)
  const [getCompanyApiLoading, setGetCompanyApiLoading] = useState(false)
  const [companyDetails, setCompanyDetails] = useState<any>()
  const {companyId} = useAuth()
  const {formatMessage} = useIntl()

  useEffect(() => {
    const fetchCountry = async () => {
      setCountryLoading(true)
      try {
        const {
          data: {data: countries},
        } = await getCountry()
  
        const countriesData = countries.map((country: CountryModel) => {
          return {
            id: country.countryId,
            label: country.country_name,
            value: country.countryId,
          }
        })
        setcountryOptions([...countriesData])
        
        const phoneCodesData = countries.map((country: CountryModel) => {
          return {
            dial_code: `+${country.phone_code}`,
            flag: `https://${process.env.REACT_APP_AWS_PUBLIC_ASSETS_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/${country.flag_icon}`,
            code: country.country_code,
            name: country.country_name,
          }
        })
        setPhoneCodesOptions([...phoneCodesData])
      } catch (error) {
        console.log(error);
        
      } finally {
        setCountryLoading(false)
      }
    
    }
    fetchCountry()
  }, [])  // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const fetchState = async () => {
      if (!countryId) {
        return
      }
      setStateDataLoading(true)
      try {
       
        const {
          data: {data: states, success},
        } = await state(countryId)
        if (success) {
          const stateData = states.map((state: any) => {
            return {
              id: state.stateId,
              label: state.state_name,
              value: state.stateId,
            }
          })
          setstateOptions([...stateData])
          setStateDataLoading(false)
        }
      } catch (err) {
        console.log(err)
        setStateDataLoading(false)
      } finally {
        setStateDataLoading(false)
      }
    }
    fetchState()
  }, [countryId]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const fetchState = async () => {
      if (!institutionCountryId) {
        return
      }
      setInstitutionStateDataLoading(true)
      try {
       
        const {
          data: {data: states, success},
        } = await state(institutionCountryId)
        if (success) {
          const stateData = states.map((state: any) => {
            return {
              id: state.stateId,
              label: state.state_name,
              value: state.stateId,
            }
          })
          setInstitutionStateOptions([...stateData])
          setInstitutionStateDataLoading(false)
        }
      } catch (err) {
        console.log(err)
        setInstitutionStateDataLoading(false)
      } finally {
        setInstitutionStateDataLoading(false)
      }
    }
    fetchState()
  }, [institutionCountryId]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const fetchGovtIdTypes = async () => {
      if (!companyId) return
      const {
        data: {data},
      } = await getGovtIdTypes(shareholderType, companyId)

      const dropdownOptions = Object.keys(data?.govtIssuedIdTypes).map((country) => ({
        label: country,
        options: data?.govtIssuedIdTypes[country].map((item: any) => ({
          name: item.label,
          id: item.id,
          value: item.slug,
        })),
      }))

      setGovtIdOptions(dropdownOptions)
    }

    fetchGovtIdTypes()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const getCompanyData = async () => {
      try {
        setGetCompanyApiLoading(true)
        if (companyId) {
          const {
            data: {success, data, errors},
          } = await companyData(companyId)
          if (success) {
            setGetCompanyApiLoading(false)
            setCompanyDetails(data)
          } else {
            setGetCompanyApiLoading(false)
            errors.forEach((error: string) => {
              toast.error(formatMessage({id: error}))
            })
          }
        }
      } catch (err) {
        console.log(err)
      }
    }
    getCompanyData()
  }, [companyId]) // eslint-disable-line react-hooks/exhaustive-deps

  return {
    countryOptions,
    countryLoading,
    stateOptions,
    setCountryId,
    setInstitutionCountryId,
    institutionStateDataLoading,
    institutionStateOptions,
    govtIdOptions,
    phoneCodesOptions,
    stateDataLoading,
    getCompanyApiLoading,
    companyDetails
  }
}
